import request from "../axios/axios";
import { AxiosMethod } from "../entities/Environment";
import { TranslationResponseInterface } from "../entities/Translation";

export enum TranslationEndpoints {
  TRANSLATIONS = "translations/public",
}

export class TranslationService {
  static getTranslations(
    languageShortName: string,
  ): Promise<TranslationResponseInterface> {
    const projectShortName = "web_configurator";
    languageShortName = languageShortName.toUpperCase();
    return request({
      url: `${TranslationEndpoints.TRANSLATIONS}?projectShortName=${projectShortName}&languageShortName=${languageShortName}`,
      method: AxiosMethod.GET,
    });
  }
}
